(function() {
    'use strict';

    angular
        .module('editorApp')
        .filter('capitalize', capitalize)
        .filter('imageFilter', imageFilter)
        .filter('serviceType', serviceType);

    capitalize.$inject = [];
    imageFilter.$inject = [];
    serviceType.$inject = ['$translate'];

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
    function imageFilter() {
        return imageFilterFilter;
    }
    function serviceType($translate) {
        return serviceTypeFilter;

        function serviceTypeFilter (item) {
            if(item === 'uv'){
                return 'UV';
            }else if(item === 'fluore'){
                return $translate.instant('serviceType.fluore');
            }else if(item === 'white'){
                return $translate.instant('serviceType.white');
            }else{
                return item;
            }
        }
    }
})();
